import * as GLightbox from 'glightbox';

const videoLightbox = () => {
  // eslint-disable-next-line no-unused-vars
  const lightbox = GLightbox({
    selector: '.u-video-lightbox',
    autoplayVideos: true,
    autofocusVideos: true,
  });
};

videoLightbox();
